/* Reconciles the $0.00 gift line against the cart total and drives the gift dropdown on
   both the cart page and the drawer. Markup: snippets/free-gift.liquid. */
(function () {
  if (window.__krfGiftPicker) return;
  window.__krfGiftPicker = true;

  var SESSION_KEY = 'krf-gift-celebrated';

  function blocks() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-krf-gift]'));
  }

  function setBusy(state) {
    blocks().forEach(function (b) { b.classList.toggle('is-busy', state); });
  }

  function status(msg) {
    blocks().forEach(function (b) {
      var el = b.querySelector('[data-krf-gift-status]');
      if (el) el.textContent = msg || '';
    });
  }

  /* A shopper's own cart change is in flight. component-cart-items.js marks <html> for the
     whole round trip, including its retry and error re-render (KRF 2026-10-05); the class is
     Horizon's own signal, kept as a fallback, but any morph strips it mid-flight. Changing
     the cart now would race the shopper's change, so callers wait and try again. */
  function cartBusy() {
    return document.documentElement.hasAttribute('data-krf-cart-busy') ||
      !!document.querySelector('cart-items-component.cart-items-disabled');
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  /* CartUpdateEvent updates counts and totals but does not add or remove the gift's own
     row, leaving a subtotal that includes an invisible line. Re-rendering the section is
     what actually shows it. */
  function refreshCartSections() {
    var comps = Array.prototype.slice.call(
      document.querySelectorAll('cart-items-component[data-section-id]')
    );
    /* Counts the shopper's cart changes started (component-cart-items.js, KRF 2026-10-05). */
    var seq = document.documentElement.getAttribute('data-krf-cart-seq');
    return Promise.all(
      comps.map(function (comp) {
        var url = window.location.pathname.indexOf('/cart') === 0 ? '/cart' : '/';
        return fetch(url + '?section_id=' + encodeURIComponent(comp.dataset.sectionId))
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var fresh = new DOMParser()
              .parseFromString(html, 'text/html')
              .querySelector('cart-items-component');
            /* A shopper change in flight, or started since this request went out, has its own
               newer response, and this older copy would bring back a row they just removed. */
            if (fresh && !cartBusy() &&
                document.documentElement.getAttribute('data-krf-cart-seq') === seq) {
              comp.innerHTML = fresh.innerHTML;
            }
          })
          .catch(function () { /* leave the stale render rather than blanking the cart */ });
      })
    );
  }

  /* Dynamic import: @theme/events resolves through the theme's import map, and a
     top-level import would take this whole file down if it ever failed. */
  function notifyCart(cart) {
    return import('@theme/events')
      .catch(function () { return {}; })
      .then(function (mod) {
        if (mod && mod.CartUpdateEvent) {
          document.dispatchEvent(
            new mod.CartUpdateEvent(cart, '', {
              itemCount: cart.item_count,
              source: 'cart-items-component'
            })
          );
        }
      })
      .then(refreshCartSections);
  }

  function findGift(cart, handles) {
    for (var i = 0; i < cart.items.length; i++) {
      if (handles.indexOf(cart.items[i].handle) !== -1) return cart.items[i];
    }
    return null;
  }

  function celebrate() {
    try {
      if (sessionStorage.getItem(SESSION_KEY)) return;
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) { /* private mode: just fire once per page */ }
    if (typeof window.krfConfetti === 'function') window.krfConfetti();
  }

  /* A promise chain, not a re-entrancy flag: any path that failed to clear a flag would
     disable reconcile for the rest of the page's life. Each call queues and always settles. */
  var chain = Promise.resolve();

  function sync() {
    chain = chain.then(function () {
      if (cartBusy()) return scheduleSync(500);
      var first = blocks()[0];
      if (!first) return;
      return doSync(first);
    }).catch(function () { /* never let one failure poison the chain */ });
    return chain;
  }

  function doSync(first) {
    var threshold = Number(first.dataset.threshold);
    var handles = (first.dataset.giftHandles || '').split(',');
    var defaultVariant = first.dataset.defaultVariant;

    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Checked again here: /cart.js can take seconds while every product form refetches
           it, and the shopper may have tapped in the meantime. */
        if (cartBusy()) return scheduleSync(500);

        var gift = findGift(cart, handles);
        /* The gift is $0 so it never inflates the total it is measured against. */
        var eligible = cart.total_price >= threshold;

        blocks().forEach(function (b) { b.hidden = !eligible; });

        if (eligible && !gift) {
          setBusy(true);
          status('Adding your free bag\u2026');
          return post('/cart/add.js', { id: defaultVariant, quantity: 1 })
            .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
            .then(function (updated) {
              setBusy(false);
              status('');
              celebrate();
              return notifyCart(updated);
            })
            .catch(function () {
              setBusy(false);
              status('Could not add your free bag. Refresh and try again.');
            });
        }

        if (!eligible && gift) {
          setBusy(true);
          return post('/cart/change.js', { id: gift.key, quantity: 0 })
            .then(function (updated) {
              setBusy(false);
              try { sessionStorage.removeItem(SESSION_KEY); } catch (e) {}
              return notifyCart(updated);
            })
            .catch(function () { setBusy(false); });
        }

        if (eligible && gift) {
          /* One gift per order, whatever put the extras there. */
          if (gift.quantity !== 1) {
            setBusy(true);
            return post('/cart/change.js', { id: gift.key, quantity: 1 })
              .then(function (updated) {
                setBusy(false);
                return notifyCart(updated);
              })
              .catch(function () { setBusy(false); });
          }

          celebrate();
          blocks().forEach(function (b) {
            var sel = b.querySelector('[data-krf-gift-select]');
            if (sel && String(sel.value) !== String(gift.variant_id)) {
              sel.value = String(gift.variant_id);
            }
          });
        }
      })
      .catch(function () { /* offline: leave the UI as rendered */ });
  }

  /* Delegated so it survives Horizon's section morphs. */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-krf-gift-select]');
    if (!sel) return;

    var first = blocks()[0];
    var handles = (first.dataset.giftHandles || '').split(',');
    var wanted = sel.value;

    setBusy(true);
    status('Updating your flavour…');

    chain = chain.then(function () {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gift = findGift(cart, handles);
        if (gift && String(gift.variant_id) === String(wanted)) return null;
        var remove = gift
          ? post('/cart/change.js', { id: gift.key, quantity: 0 })
          : Promise.resolve();
        return remove.then(function () {
          return post('/cart/add.js', { id: wanted, quantity: 1 });
        });
      })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (updated) {
        setBusy(false);
        status('Flavour updated.');
        setTimeout(function () { status(''); }, 2500);
        return notifyCart(updated);
      })
      .catch(function () {
        setBusy(false);
        status('Could not update the flavour. Refresh and try again.');
      });
    });
  });

  /* Debounced, and held while a shopper's change is in flight (cartBusy). Horizon now changes
     lines by key (KRF 2026-10-05), but adding or removing the gift still renumbers every
     line and makes the drawer stale until it re-renders. */
  var syncTimer = null;
  function scheduleSync(delay) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, delay);
  }

  document.addEventListener('cart:update', function () { scheduleSync(200); });
  document.addEventListener('cart-drawer:open', function () { scheduleSync(0); });

  /* Cart events fire before Horizon re-renders, so on the first add [data-krf-gift] is not
     in the DOM yet and nothing announces its arrival. Watch for it instead. */
  var observer = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('[data-krf-gift]')) return scheduleSync(0);
        if (node.querySelector && node.querySelector('[data-krf-gift]')) return scheduleSync(0);
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  /* Safety net: Horizon's cart events aren't a contract we control, so a morph or an add
     from an unanticipated surface can leave the gift unreconciled with nothing to tell us. */
  setInterval(function () {
    if (!document.hidden && !cartBusy()) sync();
  }, 2000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scheduleSync(0); });
  } else {
    scheduleSync(0);
  }
})();
